"use client";

import React from "react";
import { Disc, Gauge, ShieldCheck, ArrowUpRight } from "lucide-react";
const services = [{
  title: "Tire installation",
  text: "Professional mounting and seating of your new tires on the wheels.",
  icon: Disc
}, {
  title: "Precision balancing",
  text: "Computerized wheel balancing for a smoother ride with less vibration.",
  icon: Gauge
}, {
  title: "Tire & rim inspection",
  text: "A visual check of tire wear, rim condition and visible damage, plus tire pressure and TPMS status.",
  icon: ShieldCheck
}];
export default function WhatsIncluded() {
  return <section id="whatsincluded" data-nav="light" className="bg-white text-[#101D30] py-8 md:py-11">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
   <div className="grid grid-cols-1 md:grid-cols-[0.85fr_1.25fr] gap-6 md:gap-12">
    <div className="md:pt-2">
     <div className="w-9 h-[3px] bg-[#FF5A00] mb-4" />
     <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#667080] mb-2">Installation & balancing</p>
     <h2 className="text-[28px] sm:text-[34px] font-black italic uppercase leading-[1.08] tracking-tight">More than a<br /><span className="text-[#0B4DBA]">tire change.</span></h2>
     <p className="text-sm leading-relaxed text-[#505C6C] mt-4 max-w-sm">From fitting your tires to checking your rims, we take care of the details that matter.</p>
     <div className="inline-flex items-center gap-2 mt-5 py-2 px-3 bg-[#F2F4F7] rounded-md text-xs font-bold text-[#24354C]"><ShieldCheck className="w-4 h-4 text-[#0B4DBA]" />Free visual inspection · Walk-ins welcome</div>
    </div>
    <div className="border-t border-[#D8DDE4]">
     {services.map(service => <div key={service.title} className="flex gap-4 py-4 border-b border-[#D8DDE4]">
       <service.icon className="w-5 h-5 shrink-0 text-[#0B4DBA] mt-1" />
       <div><h3 className="text-base font-bold mb-1">{service.title}</h3><p className="text-sm leading-relaxed text-[#505C6C]">{service.text}</p></div>
      </div>)}
    </div>
   </div>
   <div className="relative overflow-hidden mt-6 md:mt-7 rounded-lg border border-[#E0E4E9] bg-gradient-to-r from-[#F4F5F7] to-white px-4 md:px-5 py-4 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
    <span aria-hidden="true" className="absolute inset-x-0 top-0 h-[2px] bg-gradient-to-r from-[#FF5A00] via-[#0B4DBA] to-transparent" />
    <div><p className="text-sm font-bold">Your tires. Your total. No guessing.</p><p className="text-xs text-[#596475] mt-1">Ask for availability and a quote including installation, balancing, disposal and tax.</p></div>
    <a href="tel:+14243138474" className="inline-flex items-center justify-center gap-2 bg-[#FF5A00] hover:bg-[#E04F00] text-white rounded-md px-4 py-2.5 text-sm font-bold shrink-0">Call for a quote<ArrowUpRight className="w-4 h-4" /></a>
   </div>
   <p className="text-[11px] leading-relaxed text-[#667080] mt-3">Open 7 days · 8635 W Pico Blvd · Entrance from the alley. Same-day service subject to tire availability and shop capacity.</p>
  </div>
 </section>;
}